import { render, staticRenderFns } from "./ImportAuthentication.vue?vue&type=template&id=61a630fa&scoped=true"
import script from "./ImportAuthentication.vue?vue&type=script&lang=js"
export * from "./ImportAuthentication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a630fa",
  null
  
)

export default component.exports